import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({
    providedIn: 'root'
})
export class SaSaleOrderService extends ApiService {

    index(params: any = {}) {
        return super.get(`/sa-sale-orders`, params);
    }

    store(body: any) {
        return super.post(`/sa-sale-orders`, body);
    }

    show(saSaleOrderId: number) {
        return super.get(`/sa-sale-orders/${saSaleOrderId}`);
    }

    invoices(saSaleOrderId: number) {
        return super.get(`/sa-sale-orders/${saSaleOrderId}/invoices`);
    }

    indexLines(params: any = {}) {
        return super.get('/sa-sale-order-lines', params);
    }

    edit(saSaleOrderId: number) {
        return super.get(`/sa-sale-orders/${saSaleOrderId}/edit`);
    }

    update(saSaleOrderId: number, body: any) {
        return super.put(`/sa-sale-orders/${saSaleOrderId}`, body);
    }

    cancel(saSaleOrderId: number) {
        return super.delete(`/sa-sale-orders/${saSaleOrderId}/cancel`);
    }

    prepareIndex(params: any = {}) {
        return super.get(`/sa-sale-orders/prepare`, params);
    }

    singlePrepare(saSaleOrderId: number, params: any = {}) {
        return super.get(`/sa-sale-orders/${saSaleOrderId}/prepare`, params);
    }

    storePrepare(body: any) {
        return super.post(`/sa-sale-orders/prepare`, body);
    }

    unlock(saSaleOrderId: number | null) {
        return super.put(`/sa-sale-orders/${saSaleOrderId}/unlock`, {});
    }

    tempPrepare(body: any) {
        return super.post(`/sa-sale-orders/prepare/temp`, body);
    }

    createCustomerSelect(params: any = {}) {
        return super.get(`/sa-sale-orders/create/customers/select`, params);
    }

    createProductSelect(params: any = {}) {
        return super.get(`/sa-sale-orders/create/products/select`, params);
    }

    toSupply(params: any = {}) {
        return super.get(`/sa-sale-orders/to-supply`, params);
    }

    supplyPrefill(lineId: number) {
        return super.get(`/sa-sale-order-lines/${lineId}/supply-prefill`);
    }

    updateLinePrice(lineId: number, body: { base_price: number; discount: number; discount_type: string }) {
        return super.put(`/sa-sale-order-lines/${lineId}/price`, body);
    }
}
